import { Col, Row, TabPanel } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { Typography } from '@paypalcorp/ppods-react'
import React from 'react'

import MultiOnboardingImg from '../../../../img/payment-solutions/ill_multiOnboarding.png'
import MultiAcceptImg from '../../../../img/payment-solutions/ill_multiAccept.png'
import MultiRefundImg from '../../../../img/payment-solutions/ill_multiRefunds.png'
import { saveBannerProgress } from '../../../../utils/session-utils'
import { useApplicationContext } from '../../../../context/ApplicationContext'

export default function MultiParty({ setBannerPage, setProductIntegration }) {
  const { csrf, logger, setCurrentBannerStep } = useApplicationContext()
  return (
    <>
      <TabPanel id="group4-panel4" tabId="group1-panel4">
        <Row className="onboarding-banner-cards-row">
          <Col xs={4}>
            <div
              onClick={() => {
                const sessionObject = {
                  bannerPage: 1,
                  productIntegration: 'mpOnboardSellers',
                }
                saveBannerProgress(csrf, logger, sessionObject)
                setBannerPage(1)
                setCurrentBannerStep(sessionObject)
                setProductIntegration('mpOnboardSellers')
              }}
              className="onboarding-banner-cards"
            >
              <img
                className="onboarding-banner-illustrations"
                src={MultiOnboardingImg}
              />
              <br />
              <Typography variant="title" style={{ margin: 0 }}>
                <Message id="onboarding-banner.tabFour.productOne" />
              </Typography>
              <Typography variant="body" style={{ margin: 0 }}>
                <Message id="onboarding-banner.tabFour.productOneDesc" />
              </Typography>
            </div>
          </Col>
          <Col xs={4}>
            <div
              onClick={() => {
                const sessionObject = {
                  bannerPage: 1,
                  productIntegration: 'mpAcceptPayments',
                }
                saveBannerProgress(csrf, logger, sessionObject)
                setBannerPage(1)
                setCurrentBannerStep(sessionObject)
                setProductIntegration('mpAcceptPayments')
              }}
              className="onboarding-banner-cards"
            >
              <img
                className="onboarding-banner-illustrations"
                src={MultiAcceptImg}
              />
              <br />

              <Typography variant="title" style={{ margin: 0 }}>
                <Message id="onboarding-banner.tabFour.productTwo" />
              </Typography>
              <Typography variant="body" style={{ margin: 0 }}>
                <Message id="onboarding-banner.tabFour.productTwoDesc" />
              </Typography>
            </div>
          </Col>
          <Col xs={4}>
            <div
              onClick={() => {
                const sessionObject = {
                  bannerPage: 1,
                  productIntegration: 'mpIssueRefunds',
                }
                saveBannerProgress(csrf, logger, sessionObject)
                setBannerPage(1)
                setCurrentBannerStep(sessionObject)
                setProductIntegration('mpIssueRefunds')
              }}
              className="onboarding-banner-cards"
            >
              <img
                className="onboarding-banner-illustrations"
                src={MultiRefundImg}
              />
              <br />
              <Typography variant="title" style={{ margin: 0 }}>
                <Message id="onboarding-banner.tabFour.productThree" />
              </Typography>
              <Typography variant="body" style={{ margin: 0 }}>
                <Message id="onboarding-banner.tabFour.productThreeDesc" />
              </Typography>
            </div>
          </Col>
        </Row>
      </TabPanel>
    </>
  )
}
